// Weekstaat — 5-status state-machine voor module C3 (Uren).
//
// Bron-hiërarchie:
//   - Status-overgangen uit `apps/api/src/routes/uren.ts` (CONCEPT → INGEDIEND
//     → GOEDGEKEURD/AFGEKEURD, INGEDIEND → CONCEPT bij intrekken).
//   - Spec: verlofmodule-spec §7.4 voor TVT-trigger bij goedkeuring.
//
// Workflow:
//   CONCEPT → INGEDIEND → GOEDGEKEURD
//                       ↘ AFGEKEURD → CONCEPT  (her-bewerken)
//                       ↘ CONCEPT  (intrekken naar concept)
//   * → INGETROKKEN  (medewerker trekt voor goedkeuring volledig in).

import { WorkflowEngine, type WorkflowDefinition } from '../workflow-engine'

/** Mirror van Prisma WeekstaatStatus enum. */
export type WeekstaatStatusValue =
  | 'CONCEPT'
  | 'INGEDIEND'
  | 'GOEDGEKEURD'
  | 'AFGEKEURD'
  | 'INGETROKKEN'

export const weekstaatWorkflow: WorkflowDefinition<WeekstaatStatusValue> = {
  name: 'weekstaat',
  initial: 'CONCEPT',
  states: ['CONCEPT', 'INGEDIEND', 'GOEDGEKEURD', 'AFGEKEURD', 'INGETROKKEN'],
  transitions: [
    // 1. Indienen
    {
      from: 'CONCEPT',
      to: 'INGEDIEND',
      label: 'Indienen',
      rolesAllowed: ['MONTEUR', 'TEAMLEIDER', 'PLANNER', 'HR', 'SALARIS', 'MANAGER', 'ADMIN'],
    },
    // 2. TL beoordeelt
    {
      from: 'INGEDIEND',
      to: 'GOEDGEKEURD',
      label: 'Goedkeuren',
      rolesAllowed: ['TEAMLEIDER', 'HR', 'ADMIN'],
    },
    {
      from: 'INGEDIEND',
      to: 'AFGEKEURD',
      label: 'Afkeuren',
      rolesAllowed: ['TEAMLEIDER', 'HR', 'ADMIN'],
    },
    // 3. Her-bewerken na afkeur
    {
      from: 'AFGEKEURD',
      to: 'CONCEPT',
      label: 'Bewerken na afkeur',
    },
    // 4. Intrekken naar concept (medewerker zelf, vóór beoordeling)
    {
      from: 'INGEDIEND',
      to: 'CONCEPT',
      label: 'Terugtrekken naar concept',
    },
    // 5. Volledig intrekken (eindstaat)
    {
      from: 'CONCEPT',
      to: 'INGETROKKEN',
      label: 'Intrekken',
    },
    {
      from: 'INGEDIEND',
      to: 'INGETROKKEN',
      label: 'Intrekken',
    },
  ],
}

/** Engine-instance voor weekstaten — direct importeerbaar in API-routes. */
export const weekstaatEngine = new WorkflowEngine(weekstaatWorkflow)
